import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';

import { catchError, mergeMap, tap } from 'rxjs/operators';
import { forkJoin, throwError } from 'rxjs';
import { FormPatientNephroService } from '@services/form/form-patient-nephro.service';
import { AuthService } from '@services/security';
import { FormatFormService } from './format-form.service';
import { ErrorFormService } from './error-form.service';
import { PatientService } from '../patient';

@Injectable({ providedIn: 'root' })
export class EditionNephroService {
    patient;
    cancelForm;
    typeChanged = new EventEmitter<void>();

    constructor(
        private http: HttpClient,
        private formatService: FormatFormService,
        private errorService: ErrorFormService,
        private patientService: PatientService,
        private router: Router,
        private formPatientNephroService: FormPatientNephroService,
        private authService: AuthService,
    ) {}

    initEdition(id) {
        this.errorService.resetErrors();
        return this.initPatient(id).pipe(mergeMap(() => this.initUsers()));
    }

    initUsers() {
        const promises = [
            this.formPatientNephroService.initSpecialistsFromPatient(
                this.patient,
            ),
        ];
        if (this.authService.isAdmin) promises.push(this.formPatientNephroService.initCompanies());
        if (this.authService.canEditMedicalInfos) {
            promises.push(
                this.formPatientNephroService.loadImmunosuppressants(),
            );
        }
        return forkJoin(promises);
    }

    initPatient(id) {
        return this.patientService.getPatient(id, ['logs'], 'nephro').pipe(
            tap((patient) => {
                this.patient = this.formatService.initPatient(
                    patient,
                    'nephro',
                );
            }),
        );
    }

    editPatient() {
        if (this.patient.demo) {
            this.router.navigate(['patient', this.patient._id]);

            return;
        }

        if (!this.patient.treatment?.antidiabetes) {
            this.patient.treatment.metformine = false;
            this.patient.treatment.insuline = false;
            this.patient.treatment.other = false;
            this.patient.treatment.otherDetail = '';
        }

        const formData = this.formatService.formatPatientNephro(
            this.patient,
            true,
        );

        return this.http
            .put<any>(
                `${environment.apiUrl}/patient/${this.patient._id}`,
                formData,
                {
                    params: { disease: 'nephro' },
                },
            )
            .pipe(
                tap(() => {
                    this.router.navigate(['patient', this.patient._id]);
                }),
                catchError((err) => {
                    this.errorService.initErrors(err?.error?.errors);
                    this.errorService.initSidebarError();
                    return throwError(() => err);
                }),
            );
    }
}
